module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.hasHeader) ? _c('div', {
    staticClass: "panel-heading"
  }, [(_vm.title) ? _c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("table"), _vm._v(" "), _vm._t("list"), _vm._v(" "), (_vm.hasFooter) ? _c('div', {
    staticClass: "panel-footer"
  }, [_vm._t("footer")], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26a4652b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/panel/panel.vue
// module id = 675
// module chunks = 85